module.exports = __webpack_public_path__ + "assets/img/7aed638b7e4e555d21034bd558bc090f.png";